import type { components } from '@front/generated/apiClient';
import { MutableEntity } from '@front/repository/Api/converter/common';
import { DomainV2 } from 'troppus-common/domain';

import SourceSystem = DomainV2.Import.SourceSystem;

type Api = components['schemas']['SourceSystem'];

export const fromApi = (api: Api): SourceSystem => {
  return SourceSystem.Construct({
    ...MutableEntity.fromApi(api),
    id: api.id,
    projectId: api.projectId,
    displayName: api.displayName,
    description: api.description,
    isActive: api.isActive,
  });
};
